'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = gallery;
exports.goTo = goTo;
exports.next = next;
exports.openGallery = openGallery;
exports.openAndGoTo = openAndGoTo;
exports.prev = prev;
exports.setItems = setItems;

var _media = require('utils/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GOTO = 'redux-frontend/gallery/GOTO';
var NEXT = 'redux-frontend/gallery/NEXT';
var OPEN = 'redux-frontend/gallery/OPEN';
var OPEN_AND_GOTO = 'redux-frontend/gallery/OPEN_AND_GOTO';
var PREV = 'redux-frontend/gallery/PREV';
var SET = 'redux-frontend/gallery/SET';

var initialState = {
  isOpen: false,
  activeIndex: 0,
  items: []
};

function gallery() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case GOTO:
      return (0, _extends3.default)({}, state, {
        activeIndex: action.index
      });
    case NEXT:
      return (0, _extends3.default)({}, state, {
        activeIndex: state.activeIndex + 1 >= state.items.length ? 0 : state.activeIndex + 1
      });
    case OPEN:
      return (0, _extends3.default)({}, state, {
        isOpen: action.open
      });
    case OPEN_AND_GOTO:
      return (0, _extends3.default)({}, state, {
        isOpen: true,
        activeIndex: action.index
      });
    case PREV:
      return (0, _extends3.default)({}, state, {
        activeIndex: state.activeIndex - 1 < 0 ? state.items.length - 1 : state.activeIndex - 1
      });
    case SET:
      var images = action.images.map(function (image, index) {
        return (0, _extends3.default)({}, image, {
          index: action.video ? index + 1 : index,
          style: (0, _media.path)(image.image, 'gallery', true),
          thumbnailStyle: (0, _media.path)(image.image, 'thumbnail', true),
          url: (0, _media.path)(image.image, 'mobileGallery')
        });
      });
      var video = action.video ? {
        index: 0,
        caption: '',
        thumbnailStyle: { backgroundImage: 'url(https://img.youtube.com/vi/' + action.video + '/0.jpg)' },
        style: { backgroundImage: 'url(https://img.youtube.com/vi/' + action.video + '/0.jpg)' },
        url: 'https://img.youtube.com/vi/' + action.video + '/0.jpg',
        video: 'https://www.youtube.com/embed/' + action.video + '?autoplay=1'
      } : null;
      return (0, _extends3.default)({}, state, {
        items: video ? [video].concat((0, _toConsumableArray3.default)(images)) : images
      });
    default:
      return state;
  }
}

function goTo(index) {
  return {
    type: GOTO,
    index: index
  };
}

function next() {
  return {
    type: NEXT
  };
}

function openGallery() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN,
    open: open
  };
}

function openAndGoTo(index) {
  return {
    type: OPEN_AND_GOTO,
    index: index
  };
}

function prev() {
  return {
    type: PREV
  };
}

function setItems(images, video) {
  return {
    type: SET,
    images: images,
    video: video
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/gallery.js
// module id = 218
// module chunks = 47